import { Tokens, User, UserRole } from '@tassomutuo-backoffice/types';

const TOKENS_KEY = 'tokens';
const HS_OWNER_ID_KEY = 'hsOwnerId';
const HS_EMAIL_KEY = 'hsEmail';
const HS_ALERT_KEY = 'hsUpdateAlert';
const HS_UPDATE_ALERT_DATE_KEY = 'hsUpdateAlertDate';
const IMPERSONATED_USER_ID_KEY = 'impersonatedUserId';
const USER_KEY = 'user';

export const removeApiTokensInLocalStorage = () => {
  localStorage.removeItem(TOKENS_KEY);
};

export const setApiTokensInLocalStorage = (tokens: Tokens) => {
  localStorage.setItem(TOKENS_KEY, JSON.stringify(tokens));
};

export const getApiTokensInLocalStorage = (): null | Tokens => {
  const apiTokenInLocalStorage = localStorage.getItem(TOKENS_KEY);
  if (apiTokenInLocalStorage) {
    return JSON.parse(apiTokenInLocalStorage);
  }
  return null;
};

export const getHsOwnerIdInLocalStorage = (): null | string => {
  const hsOwnerIdInLocalStorage = localStorage.getItem(HS_OWNER_ID_KEY);
  if (hsOwnerIdInLocalStorage) {
    return JSON.parse(hsOwnerIdInLocalStorage);
  }
  return null;
};

export const removeHsOwnerIdInLocalStorage = () => {
  localStorage.removeItem(HS_OWNER_ID_KEY);
};

export const getImpersonatedUserIdInLocalStorage = (): null | string => {
  const impersonatedUserId = localStorage.getItem(IMPERSONATED_USER_ID_KEY);
  return impersonatedUserId ? JSON.parse(impersonatedUserId) : null;
};

export const setImpersonatedUserIdInLocalStorage = (userId: string) => {
  localStorage.setItem(IMPERSONATED_USER_ID_KEY, JSON.stringify(userId));
};

export const removeImpersonatedUserIdInLocalStorage = () => {
  localStorage.removeItem(IMPERSONATED_USER_ID_KEY);
};

export const clearImpersonationInLocalStorage = () => {
  removeHsOwnerIdInLocalStorage();
  removeHsEmailInLocalStorage();
  removeHsAlertInLocalStorage();
  removeHsAlertDateInLocalStorage();
  removeImpersonatedUserIdInLocalStorage();
};

export const clearAuthenticationInLocalStorage = () => {
  removeApiTokensInLocalStorage();
  removeUserInLocalStorage();
  clearImpersonationInLocalStorage();
};

export const setHsOwnerIdInLocalStorage = (hsOwnerId: string) => {
  localStorage.setItem(HS_OWNER_ID_KEY, JSON.stringify(hsOwnerId));
};

export const getHsEmailInLocalStorage = (): null | string => {
  const hsEmailInLocalStorage = localStorage.getItem(HS_EMAIL_KEY);
  if (hsEmailInLocalStorage) {
    return JSON.parse(hsEmailInLocalStorage);
  }
  return null;
};

export const getHsUpdateAlertInLocalStorage = (): boolean | false => {
  const hsUpdateAlertInLocalStorage = localStorage.getItem(HS_ALERT_KEY);
  if (hsUpdateAlertInLocalStorage) {
    return JSON.parse(hsUpdateAlertInLocalStorage);
  }
  return false;
};

export const getHsUpdateAlertDateInLocalStorage = (): null | string => {
  const hsUpdateAlertDateInLocalStorage = localStorage.getItem(
    HS_UPDATE_ALERT_DATE_KEY
  );
  if (
    hsUpdateAlertDateInLocalStorage &&
    hsUpdateAlertDateInLocalStorage !== 'undefined'
  ) {
    return JSON.parse(hsUpdateAlertDateInLocalStorage);
  }
  return null;
};

export const removeHsEmailInLocalStorage = () => {
  localStorage.removeItem(HS_EMAIL_KEY);
};

export const removeHsAlertInLocalStorage = () => {
  localStorage.removeItem(HS_ALERT_KEY);
};

export const removeHsAlertDateInLocalStorage = () => {
  localStorage.removeItem(HS_UPDATE_ALERT_DATE_KEY);
};

export const setHsEmailInLocalStorage = (email: string) => {
  localStorage.setItem(HS_EMAIL_KEY, JSON.stringify(email));
};

export const setHsAlertInLocalStorage = (alert: boolean) => {
  localStorage.setItem(HS_ALERT_KEY, JSON.stringify(alert));
};

export const setHsUpdateAlertDateInLocalStorage = (
  alertDate: string | null
) => {
  localStorage.setItem(HS_UPDATE_ALERT_DATE_KEY, JSON.stringify(alertDate));
};

export const setUserInLocalStorage = (user: User) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const removeUserInLocalStorage = () => {
  localStorage.removeItem(USER_KEY);
};

export const getUserInLocalStorage = (): null | User => {
  const userInLocalStorage = localStorage.getItem(USER_KEY);
  if (userInLocalStorage) {
    return JSON.parse(userInLocalStorage);
  }
  return null;
};

export const getUserRoleInLocalStorage = (): null | UserRole => {
  const user = getUserInLocalStorage();
  return user?.role || null;
};
